import React from 'react';
import styles from './ItemsView.module.css';
import { ItemDTO } from '../../Networking/Interface/Account/AccountInterface';

type ItemsViewProps = {
    items: ItemDTO[];
};

const ItemsView: React.FC<ItemsViewProps> = ({ items }) => {
    if (!items || items.length === 0) {
        return (
            <div className={styles.emptyState}>
                No items found.
            </div>
        );
    }

    return (
        <div className={styles.itemsContainer}>
            <h3 className={styles.title}>Inventory</h3>
            <div className={styles.itemsGrid}>
                {items.map((item, index) => (
                    <div key={index} className={styles.itemCard}>
                        <span className={styles.itemName}>{item.itemName}</span>
                        <span className={styles.quantity}>×{item.quantity}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ItemsView;
